import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const InfoRow = ({ label, value }) => (
  <div className="space-y-1">
    <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
    <p className="text-sm font-semibold text-gray-900 break-words">{value ?? "N/A"}</p>
  </div>
);

const FlowType1ConfirmationModal = ({
  isOpen,
  onClose,
  onProceed,
  summaryData = {},
  loading = false,
}) => {
  if (!isOpen) return null;

  const {
    memberName,
    providerName,
    coverageName,
    transNo,
    corpName,
    planExpiry,
    gender,
    age,
    dateIssued,
    validUntil,
    physicianName,
    physicianEntryMode,
    profFee,
    chiefComplaint,
  } = summaryData;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-y-0 left-0 z-50 tracker-aware-modal-layer flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          className="w-full max-w-5xl bg-white rounded-2xl shadow-2xl border border-gray-100 p-6 max-h-[90vh] overflow-y-auto"
        >
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-xs uppercase tracking-wide text-gray-500">
                Flow Type 1 Confirmation
              </p>
              <h2 className="text-2xl font-semibold text-gray-900">
                Review before generating LOA
              </h2>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              x
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-gray-50 p-4 rounded-xl mb-4">
            <InfoRow label="Member Name" value={memberName} />
            <InfoRow label="Transaction #" value={transNo} />
            <InfoRow label="Coverage" value={coverageName} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl mb-4">
            <InfoRow label="Company" value={corpName} />
            <InfoRow label="Plan Expiry" value={planExpiry} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-gray-50 p-4 rounded-xl mb-4">
            <InfoRow label="Provider" value={providerName} />
            <InfoRow label="Gender" value={gender} />
            <InfoRow label="Age" value={age} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl mb-4">
            <InfoRow label="Date Issued" value={dateIssued} />
            <InfoRow label="Valid Until" value={validUntil} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl mb-4">
            <InfoRow label="Physician" value={physicianName} />
            <InfoRow
              label="Physician Entry"
              value={physicianEntryMode === "free_text" ? "Free Text" : "Dropdown"}
            />
            <InfoRow
              label="Professional Fee/PCP Rate"
              value={profFee ? `PHP ${profFee}` : "N/A"}
            />
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4">
            <p className="text-sm font-medium text-gray-600 mb-2">Chief Complaint</p>
            <p className="text-sm text-gray-800 bg-gray-50 p-3 rounded-md min-h-[56px]">
              {chiefComplaint || "None"}
            </p>
          </div>

          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
              disabled={loading}
            >
              Back
            </button>
            <button
              onClick={onProceed}
              className="px-4 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition disabled:opacity-60"
              disabled={loading}
            >
              {loading ? "Processing..." : "Proceed to Generate LOA"}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default FlowType1ConfirmationModal;
